import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";

export function Layout() {
    return (
        <div className="min-h-screen bg-ink grain">
            <Navbar />
            <CartDrawer />
            <main className="pt-[72px] relative z-10">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
